import {i18n} from '@yourcoach/i18n';

import type {CourseApiModel} from '../../../api/course';
import type {
  MembershipApiModel,
  MembershipExpandedCommon,
} from '../../../api/membership';
import type {CardApiModel} from '../../../api/payment/card';
import type {EditionApiModel} from '../../../api/program/edition';

import {membershipStore} from '../../../api/membership';
import {logger} from '../../logger';
import {showJoinProgramSuccessAlert} from './joinProgramSuccessAlert';

export const joinProgram = async ({
  course,
  edition,
  paymentMethod,
  placeForLogging,
  proposedMembership,
  signature,
}: {
  course?: CourseApiModel;
  edition: EditionApiModel;
  paymentMethod?: CardApiModel;
  placeForLogging?: string;
  proposedMembership?: MembershipApiModel;
  signature: string;
}) => {
  let signedMembership: MembershipExpandedCommon & {
    course: CourseApiModel | null;
  };

  if (proposedMembership) {
    logger.event(
      'invite_accept_confirm_tap',
      placeForLogging ? {place: placeForLogging} : undefined,
    );

    signedMembership = (await membershipStore.client.accept(
      proposedMembership,
      {
        card_id: paymentMethod ? paymentMethod._id : null,
        expand: {
          membership: ['course_id'],
        },
        sign: signature,
      },
    )) as typeof signedMembership;

    logger.event(
      'invite_accept_confirm_success_view',
      placeForLogging ? {place: placeForLogging} : undefined,
    );
  } else {
    signedMembership = (await membershipStore.client.create({
      card_id: paymentMethod ? paymentMethod._id : null,
      course_id: course ? course._id : null,
      edition_id: edition._id,
      expand: {
        membership: ['course_id'],
      },
      sign: signature,
    })) as typeof signedMembership;
  }

  if (signedMembership.status === 'requested') {
    logger.event('request_join_send_tap');

    showJoinProgramSuccessAlert([i18n.t('shared:your_request_sent')]);

    logger.event('request_join_send_confirmation_view');
  } else {
    showJoinProgramSuccessAlert([
      i18n.t('shared:congrats'),
      i18n.t('shared:you_have_successfully_enrolled'),
    ]);
  }

  return signedMembership;
};
